import pinia from "@/stores";
import {useAuthStore} from "@/stores/auth";
import {useAppStore} from "@/stores/app";
import {getAuthenticatedHomeRouteName} from "@/utils/authRouteUtils";

export default {
  install(Vue) {
    function navigate(router, routeName, params = {}, query = {}, withReplace = false) {
      const method = withReplace ? 'replace' : 'push';
      router[method]({name: routeName, params, query}).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.info(err.message);
        }
      });
    }

    // General navigation method
    Vue.prototype.$navigate = function(routeName, options = {}) {
      const { params = {}, query = {}, withReplace = false } = options;
      navigate(this.$router, routeName, params, query, withReplace);
    };

    Vue.prototype.$navigateToExternalEntryRoute = function(routeName, options = {}) {
      const appStore = useAppStore(pinia);
      appStore.armExternalEntryRootRoute(routeName);
      this.$navigate(routeName, options);
    };

    // Specific routes
    Vue.prototype.$navigateToStartPage = function(withReplace = true) {
      const authStore = useAuthStore(pinia);
      this.$navigate(getAuthenticatedHomeRouteName(window.config, authStore), { withReplace });
    }

    Vue.prototype.$navigateToDashboard = function(withReplace = false) {
      this.$navigate('Dashboard', { withReplace });
    };

    Vue.prototype.$navigateToRegister = function(withReplace = false) {
      this.$navigate('Register', { withReplace });
    };

    Vue.prototype.$navigateToRegisterChild = function() {
      this.$navigate('RegisterChild');
    };

    Vue.prototype.$navigateToRegisterParent = function() {
      this.$navigate('RegisterParent');
    };

    Vue.prototype.$navigateToRegisterGuest = function() {
      this.$navigate('RegisterGuest');
    };

    Vue.prototype.$navigateToForgotPassword = function() {
      this.$navigate('ForgotPassword');
    };

    Vue.prototype.$navigateToOrderMenuParameters = function(withReplace = false) {
        this.$navigate('OrderMenuParameters', { withReplace });
    };

    Vue.prototype.$navigateToOrderMenuParametersPreselect = function(shopId, withReplace = false) {
      this.$navigate('OrderMenuParameters', {
        params: { shopId },
        withReplace
      });
    };

    Vue.prototype.$navigateToMealPlanParameters = function(withReplace = false) {
      this.$navigate('MealPlanParameters', { withReplace });
    };

    Vue.prototype.$navigateToMealPlanOverview = function(withReplace = false) {
      this.$navigate('MealPlanOverview', { withReplace });
    };

    Vue.prototype.$navigateToOrderMenuPlanner = function(withReplace = false) {
      this.$navigate('OrderMenuPlanner', { withReplace });
    };

    Vue.prototype.$navigateToAccount = function(withReplace = false) {
      this.$navigate('Account', { withReplace });
    };

    Vue.prototype.$navigateToTemplate = function() {
      this.$navigate('Template');
    };

    Vue.prototype.$navigateToCustomerCard = function(withReplace = false) {
      this.$navigate('CustomerCard', { withReplace });
    };

    Vue.prototype.$navigateToPasswordReset = function() {
      this.$navigate('PasswordReset');
    };

    Vue.prototype.$navigateToEditAddress = function(id, withReplace = false) {
      this.$navigate('EditAddress', {
        params: { id },
        withReplace
      });
    };

    Vue.prototype.$navigateToCreateAddress = function(withReplace = false) {
      this.$navigate('CreateAddress', { withReplace });
    };

    Vue.prototype.$navigateToEditCustomer = function() {
      this.$navigate('EditCustomer');
    };

    Vue.prototype.$navigateToAddressBook = function(withReplace = false) {
      this.$navigate('AddressBook' , { withReplace });
    };

    Vue.prototype.$navigateToTableOrder = function(withReplace = false) {
      this.$navigate('TableOrder' , { withReplace });
    };

    Vue.prototype.$navigateToTakeawayOrder = function(withReplace = false) {
      this.$navigate('TakeawayOrder' , { withReplace });
    };

    Vue.prototype.$navigateToTopUp = function(customerId = 0) {
      const params = customerId ? { customerId } : {};
      this.$navigate('TopUp', { params });
    };

    Vue.prototype.$navigateToTopUpPayment = function() {
      this.$navigate('TopUpPayment');
    };

    Vue.prototype.$navigateToAutoTopUp = function(customerId) {
      const params = customerId ? { customerId } : {};
      this.$navigate('AutoTopUp', { params });
    };

    Vue.prototype.$navigateToOrderHistory = function() {
      this.$navigate('OrderHistory');
    };

    Vue.prototype.$navigateToTransactionHistory = function(isChild = false, customerId = 0) {
        if (isChild && customerId > 0) {
            this.$router.push({ name: 'TransactionHistory', params: { customerId: customerId }, query: { isChild: isChild } });
        } else {
            this.$router.push({ name: 'TransactionHistory' });
        }
    };

    Vue.prototype.$navigateToMealPlanner = function(withReplace = false) {
      this.$navigate('MealPlanner', { withReplace });
    };

    Vue.prototype.$navigateToStudentAccounts = function(withReplace = false) {
      this.$navigate('StudentAccounts', { withReplace });
    };

    Vue.prototype.$navigateToOrderMenuCheckout = function(withReplace = false) {
      this.$navigate('OrderMenuCheckout', { withReplace });
    };

    Vue.prototype.$navigateToMealPlanCheckout = function(withReplace = false) {
      this.$navigate('MealPlanCheckout', { withReplace });
    };

    Vue.prototype.$navigateToErrorSSO = function() {
      this.$navigate('ErrorSSO', { withReplace: true });
    };

    Vue.prototype.$navigateToErrorLanding = function(sessionTimeout = false) {
      const params = sessionTimeout ? { sessionTimeout } : {};
      this.$navigate('ErrorLanding', { params, withReplace: true });
    };

    Vue.prototype.$navigateToOrderMenuConfirmation = function(withReplace = false) {
      this.$navigate('OrderMenuConfirmation', { withReplace });
    };

    Vue.prototype.$navigateToLogin = function() {
      this.$navigate('Login', { withReplace: true });
    };
  },
};
